module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-row', {
    staticClass: "statusRow"
  }, [_c('el-col', [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-select', {
    staticClass: "xs24",
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "请选择发行游戏名称"
    },
    model: {
      value: (_vm.issued_app_id),
      callback: function($$v) {
        _vm.issued_app_id = $$v
      },
      expression: "issued_app_id"
    }
  }, _vm._l((_vm.PlacementList), function(item, i) {
    return _c('el-option', {
      key: item.issued_app_id,
      attrs: {
        "label": item.name,
        "value": item.issued_app_id
      }
    })
  }), 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "medium",
      "type": "primary"
    },
    on: {
      "click": _vm.planConfig
    }
  }, [_vm._v("同步线上配置")])], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "statusRow"
  }, [_c('el-button', {
    attrs: {
      "size": "medium",
      "type": "primary"
    },
    on: {
      "click": _vm.addProduct
    }
  }, [_vm._v("新增广告主游戏")]), _vm._v(" 当前线上创意： " + _vm._s(_vm.online_ceative_num) + "      当前线上产品数量： " + _vm._s(_vm.online_product_num) + "\n\t\t")], 1), _vm._v(" "), _c('el-row', {
    staticClass: "statusRow"
  }, [_c('el-button', {
    attrs: {
      "size": "medium",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.showList = 1
      }
    }
  }, [_vm._v("直跳")]), _vm._v(" "), (_vm.jumpList.length > 0) ? _c('el-button', {
    attrs: {
      "size": "medium",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.showList = 2
      }
    }
  }, [_vm._v("二跳")]) : _vm._e()], 1), _vm._v(" "), (_vm.showList == 1) ? _c('el-row', {
    staticClass: "statusRow"
  }, [_c('el-button', {
    attrs: {
      "size": "medium",
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.changeStatus(false, 1)
      }
    }
  }, [_vm._v("启用")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "medium",
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.changeStatus(false, 0)
      }
    }
  }, [_vm._v("禁用")]), _vm._v(" "), _c('el-input', {
    ref: "input",
    staticClass: "search  xs24",
    attrs: {
      "clearable": "",
      "placeholder": "请输入产品名称/创意名称",
      "suffix-icon": _vm.pdata.kw.length > 0 ? '' : 'el-icon-search'
    },
    on: {
      "clear": _vm.getList
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search($event)
      }
    },
    model: {
      value: (_vm.pdata.kw),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "kw", $$v)
      },
      expression: "pdata.kw"
    }
  }), _vm._v(" "), _c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择产品来源"
    },
    model: {
      value: (_vm.pdata.source),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "source", $$v)
      },
      expression: "pdata.source"
    }
  }, [_c('el-option', {
    key: "1",
    attrs: {
      "label": "互导",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    key: "2",
    attrs: {
      "label": "卖量",
      "value": "2"
    }
  }), _vm._v(" "), _c('el-option', {
    key: "3",
    attrs: {
      "label": "测量",
      "value": "3"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.showList == 1) ? _c('el-table', {
    staticStyle: {
      "width": "100%",
      "min-width": "1200px"
    },
    attrs: {
      "data": _vm.plist,
      "stripe": "",
      "row-key": "id",
      "row-class-name": _vm.tableRowClassName
    },
    on: {
      "selection-change": _vm.select
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "ID",
      "min-width": "80px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "产品名称",
      "align": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text",
            "title": scope.row.name
          },
          on: {
            "click": function($event) {
              return _vm.editProduct(scope.row)
            }
          }
        }, [_vm._v(_vm._s(scope.row.name))])]
      }
    }], null, false, 1895011517)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "icon",
      "label": "产品来源",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.source == 1) ? _c('span', [_vm._v("互导")]) : _vm._e(), _vm._v(" "), (scope.row.source == 2) ? _c('span', [_vm._v("卖量")]) : _vm._e(), _vm._v(" "), (scope.row.source == 3) ? _c('span', [_vm._v("测量")]) : _vm._e()]
      }
    }], null, false, 3952880682)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "icon",
      "label": "创意类型",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.jump_type == 1 ? '直跳' : '二跳'))])]
      }
    }], null, false, 2341541455)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "icon",
      "label": "创意个数",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.creative_num.ok) + "/" + _vm._s(scope.row.creative_num.count))])]
      }
    }], null, false, 2961733699)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "path",
      "label": "产品路径",
      "width": "250px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('a', {
          staticStyle: {
            "white-space": "nowrap",
            "overflow": "hidden",
            "text-overflow": "ellipsis"
          },
          attrs: {
            "title": scope.row.path
          }
        }, [_vm._v(_vm._s(scope.row.path))])]
      }
    }], null, false, 3179830934)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "update_time",
      "label": "更新时间",
      "width": "220px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "​产品状态",
      "align": "center",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a._status - 0) - (b._status - 0)
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row._status == 1) ? _c('span', [_vm._v("待启用")]) : _vm._e(), _vm._v(" "), (scope.row._status == 2) ? _c('span', [_vm._v("待禁用")]) : _vm._e(), _vm._v(" "), (scope.row._status == 3) ? _c('span', [_vm._v("正常")]) : _vm._e(), _vm._v(" "), (scope.row._status == 4) ? _c('span', [_vm._v("禁用")]) : _vm._e()]
      }
    }], null, false, 1159561416)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "操作",
      "width": "250px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "mini",
            "type": scope.row.status == '1' ? 'success' : 'danger'
          },
          on: {
            "click": function($event) {
              return _vm.editStatus(scope.row)
            }
          }
        }, [_vm._v(_vm._s(scope.row.status == '1' ? '正常' : '禁用'))]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.$router.push({
                name: '创意投放日志',
                params: {
                  index_id: scope.row.id
                },
                query: {
                  type: 'creative'
                }
              })
            }
          }
        }, [_vm._v("更新日志")])]
      }
    }], null, false, 1682824023)
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showList == 2) ? _c('div', {
    staticClass: "el-table el-table--fit el-table--striped el-table--border el-table--group el-table--enable-row-hover el-table--enable-row-transition",
    staticStyle: {
      "width": "100%",
      "min-width": "1200px"
    }
  }, [_c('div', {
    staticClass: "el-table__body-wrapper"
  }, [_c('table', {
    staticClass: "el-table__header",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "cellspacing": "0",
      "cellpadding": "0",
      "border": "0"
    }
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._l((_vm.jumpList), function(item, index) {
    return (item.data && item.data.length > 0) ? _c('tbody', _vm._l((item.data), function(it, idx) {
      return _c('tr', {
        staticClass: "el-table__row ",
        class: index % 2 == 0 ? 'el-table__row--striped' : ''
      }, [(idx == 0) ? _c('td', {
        staticClass: "is-center ",
        attrs: {
          "rowspan": item.data.length
        }
      }, [_vm._v(_vm._s(item.id))]) : _vm._e(), _vm._v(" "), _c('td', {
        staticClass: "is-center ",
        attrs: {
          "title": it.name
        }
      }, [_vm._v(_vm._s(it.name))]), _vm._v(" "), _c('td', {
        staticClass: "is-center "
      }, [(it.source == 1) ? _c('span', [_vm._v("互导")]) : _vm._e(), _vm._v(" "), (it.source == 2) ? _c('span', [_vm._v("卖量")]) : _vm._e(), _vm._v(" "), (it.source == 3) ? _c('span', [_vm._v("测量")]) : _vm._e()]), _vm._v(" "), _c('td', {
        staticClass: "is-center "
      }, [_vm._v(_vm._s(it.bale_name))]), _vm._v(" "), _c('td', {
        staticClass: "is-center "
      }, [_vm._v(_vm._s(it.creative_num.ok) + "/" + _vm._s(it.creative_num.count))]), _vm._v(" "), _c('td', {
        staticClass: "is-center ",
        attrs: {
          "title": it.path
        }
      }, [_vm._v(_vm._s(it.path))]), _vm._v(" "), _c('td', {
        staticClass: "is-center "
      }, [_vm._v(_vm._s(it.status == 1 ? '启用' : '禁用'))]), _vm._v(" "), (idx == 0) ? _c('td', {
        staticClass: "is-center ",
        attrs: {
          "rowspan": item.data.length
        }
      }, [_vm._v(_vm._s(item.update_time))]) : _vm._e(), _vm._v(" "), (idx == 0) ? _c('td', {
        staticClass: "is-center ",
        attrs: {
          "rowspan": item.data.length
        }
      }, [_c('el-button', {
        attrs: {
          "size": "mini",
          "type": item.status == '1' ? 'success' : 'danger'
        },
        on: {
          "click": function($event) {
            return _vm.editStatus(item)
          }
        }
      }, [_vm._v(_vm._s(item.status == '1' ? '正常' : '禁用'))]), _vm._v(" "), _c('el-button', {
        attrs: {
          "type": "text"
        },
        on: {
          "click": function($event) {
            return _vm.$router.push({
              name: '创意投放日志',
              params: {
                index_id: item.id
              },
              query: {
                type: 'creative'
              }
            })
          }
        }
      }, [_vm._v("更新日志")])], 1) : _vm._e()])
    }), 0) : _c('tbody', [_c('tr', [_c('td', {
      staticClass: "is-center "
    }, [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', {
      staticClass: "is-center "
    }, [_vm._v("-")]), _vm._v(" "), _c('td', {
      staticClass: "is-center "
    }, [_vm._v("\n\t\t    \t\t\t-\n\t\t    \t\t")]), _vm._v(" "), _c('td', {
      staticClass: "is-center "
    }, [_vm._v("-")]), _vm._v(" "), _c('td', {
      staticClass: "is-center "
    }, [_vm._v("-")]), _vm._v(" "), _c('td', {
      staticClass: "is-center "
    }, [_vm._v("-")]), _vm._v(" "), _c('td', {
      staticClass: "is-center "
    }, [_vm._v("-")]), _vm._v(" "), _c('td', {
      staticClass: "is-center"
    }, [_vm._v(_vm._s(item.update_time))]), _vm._v(" "), _c('td', {
      staticClass: "is-center "
    }, [_c('el-button', {
      attrs: {
        "size": "mini",
        "type": item.status == '1' ? 'success' : 'danger'
      },
      on: {
        "click": function($event) {
          return _vm.editStatus(item)
        }
      }
    }, [_vm._v(_vm._s(item.status == '1' ? '正常' : '禁用'))]), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "text"
      },
      on: {
        "click": function($event) {
          return _vm.$router.push({
            name: '创意投放日志',
            params: {
              index_id: item.id
            },
            query: {
              type: 'creative'
            }
          })
        }
      }
    }, [_vm._v("更新日志")])], 1)])])
  })], 2)])]) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.isAdd ? '新增创意' : '编辑创意',
      "visible": _vm.editDialog,
      "width": "950px",
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.editDialog = $event
      }
    }
  }, [_c('el-form', {
    ref: "ruleForm",
    attrs: {
      "model": _vm.chooseProduct,
      "rules": _vm.rules,
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "跳转方式",
      "prop": "jump_type"
    }
  }, [_c('el-radio-group', {
    attrs: {
      "disabled": _vm.isAdd ? false : true
    },
    model: {
      value: (_vm.chooseProduct.jump_type),
      callback: function($$v) {
        _vm.$set(_vm.chooseProduct, "jump_type", $$v)
      },
      expression: "chooseProduct.jump_type"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "1"
    }
  }, [_vm._v("直跳")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "2"
    }
  }, [_vm._v("二跳")])], 1)], 1), _vm._v(" "), (_vm.chooseProduct.jump_type != 2) ? _c('div', [_c('el-form-item', {
    attrs: {
      "label": "产品选择",
      "prop": "product_base_id"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "请从产品管理里选择产品",
      "disabled": _vm.isAdd ? false : true
    },
    model: {
      value: (_vm.chooseProduct.product_base_id),
      callback: function($$v) {
        _vm.$set(_vm.chooseProduct, "product_base_id", $$v)
      },
      expression: "chooseProduct.product_base_id"
    }
  }, _vm._l((_vm.productList), function(item) {
    return _c('el-option', {
      key: item.product_base_id,
      attrs: {
        "label": item.name,
        "value": item.product_base_id,
        "default-first-option": ""
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "myItems",
    staticStyle: {
      "margin-bottom": "0"
    },
    attrs: {
      "label": "",
      "prop": "data"
    }
  }, [_c('el-row', {
    staticStyle: {
      "margin": "0"
    },
    attrs: {
      "gutter": 5
    }
  }, [_c('el-col', {
    staticStyle: {
      "margin": "0  0 10px 0"
    },
    attrs: {
      "span": 3
    }
  }, [_vm._v("序号")]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "margin": "0  0 10px 0"
    },
    attrs: {
      "span": 5
    }
  }, [_vm._v("创意名称")]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "margin": "0  0 10px 0"
    },
    attrs: {
      "span": 4
    }
  }, [_vm._v("创意权重")]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "margin": "0  0 10px 0"
    },
    attrs: {
      "span": 3
    }
  }, [_vm._v("创意帧数")]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "margin": "0  0 10px 0"
    },
    attrs: {
      "span": 4
    }
  }, [_vm._v("角标")]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "margin": "0  0 10px 0"
    },
    attrs: {
      "span": 5
    }
  }, [_vm._v("操作")])], 1)], 1), _vm._v(" "), _vm._l((_vm.chooseProduct.data), function(item, index) {
    return _c('el-form-item', {
      staticClass: "myItems",
      attrs: {
        "label": "",
        "prop": "data"
      }
    }, [_c('el-row', {
      staticStyle: {
        "margin": "0"
      },
      attrs: {
        "gutter": 5
      }
    }, [_c('el-col', {
      staticStyle: {
        "margin": "0  0 10px 0"
      },
      attrs: {
        "span": 3
      }
    }, [_c('el-button', {
      attrs: {
        "size": "mini",
        "type": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.addCreative(true, index)
        }
      }
    }, [_vm._v("新增")]), _vm._v("\n\t\t     \t\t\t \t\t创意" + _vm._s(index + 1) + ":\n\t\t     \t\t\t \t")], 1), _vm._v(" "), _c('el-col', {
      staticStyle: {
        "margin": "0  0 10px 0"
      },
      attrs: {
        "span": 5
      }
    }, [(!item.isAdd) ? _c('span', [_vm._v(_vm._s(item.rename))]) : _vm._e(), _vm._v(" "), (item.isAdd) ? _c('el-input', {
      staticClass: "input",
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "placeholder": "请输入创意名称",
        "clearable": ""
      },
      model: {
        value: (item.rename),
        callback: function($$v) {
          _vm.$set(item, "rename", $$v)
        },
        expression: "item.rename"
      }
    }) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
      staticStyle: {
        "margin": "0  0 10px 0"
      },
      attrs: {
        "span": 4
      }
    }, [(!item.isAdd) ? _c('span', [_vm._v(_vm._s(item.weight))]) : _vm._e(), _vm._v(" "), (item.isAdd) ? _c('el-input', {
      staticClass: "input",
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "placeholder": "请输入创意权重",
        "clearable": ""
      },
      model: {
        value: (item.weight),
        callback: function($$v) {
          _vm.$set(item, "weight", $$v)
        },
        expression: "item.weight"
      }
    }) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
      staticStyle: {
        "margin": "0  0 10px 0"
      },
      attrs: {
        "span": 3
      }
    }, [(!item.isAdd) ? _c('span', [_vm._v(_vm._s(item.frame))]) : _vm._e(), _vm._v(" "), (item.isAdd) ? _c('el-input', {
      staticClass: "input",
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "placeholder": "请输入创意帧数",
        "clearable": ""
      },
      model: {
        value: (item.frame),
        callback: function($$v) {
          _vm.$set(item, "frame", $$v)
        },
        expression: "item.frame"
      }
    }) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
      staticStyle: {
        "margin": "0  0 10px 0"
      },
      attrs: {
        "span": 4
      }
    }, [(!item.isAdd) ? _c('span', [(item.heat == 1) ? _c('span', [_vm._v("红点")]) : _vm._e(), _vm._v(" "), (item.heat == 2) ? _c('span', [_vm._v("热门")]) : _vm._e(), _vm._v(" "), (item.heat == 3) ? _c('span', [_vm._v("New")]) : _vm._e(), _vm._v(" "), (item.heat == 4) ? _c('span', [_vm._v("感叹号")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (item.isAdd) ? _c('el-select', {
      attrs: {
        "filterable": "",
        "placeholder": "请选择角标"
      },
      model: {
        value: (item.heat),
        callback: function($$v) {
          _vm.$set(item, "heat", $$v)
        },
        expression: "item.heat"
      }
    }, [_c('el-option', {
      key: "0",
      attrs: {
        "label": "无",
        "value": "0"
      }
    }), _vm._v(" "), _c('el-option', {
      key: "1",
      attrs: {
        "label": "红点",
        "value": "1"
      }
    }), _vm._v(" "), _c('el-option', {
      key: "2",
      attrs: {
        "label": "热门",
        "value": "2"
      }
    }), _vm._v(" "), _c('el-option', {
      key: "3",
      attrs: {
        "label": "New",
        "value": "3"
      }
    }), _vm._v(" "), _c('el-option', {
      key: "4",
      attrs: {
        "label": "感叹号",
        "value": "4"
      }
    })], 1) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
      staticStyle: {
        "margin": "0  0 10px 0"
      },
      attrs: {
        "span": 5
      }
    }, [_c('el-button', {
      attrs: {
        "size": "mini",
        "type": item.status == '1' ? 'success' : 'danger'
      },
      on: {
        "click": function($event) {
          return _vm.changeCreative(index)
        }
      }
    }, [_vm._v(_vm._s(item.status == '1' ? '正常' : '禁用'))]), _vm._v(" "), _c('el-button', {
      attrs: {
        "size": "mini",
        "type": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.editCreative(index)
        }
      }
    }, [_vm._v("编辑")]), _vm._v(" "), (!item.creative_id && index > 0) ? _c('el-button', {
      attrs: {
        "size": "mini",
        "type": "danger"
      },
      on: {
        "click": function($event) {
          return _vm.deleteCreative(index)
        }
      }
    }, [_vm._v("删除")]) : _vm._e()], 1)], 1), _vm._v(" "), (item.isAdd) ? _c('el-row', {
      staticStyle: {
        "margin": "0"
      },
      attrs: {
        "gutter": 10
      }
    }, [_c('el-col', {
      staticStyle: {
        "margin": "0  0 10px 0"
      },
      attrs: {
        "span": 3
      }
    }, [_vm._v(" ")]), _vm._v(" "), _c('el-col', {
      staticStyle: {
        "margin": "0  0 10px 0"
      },
      attrs: {
        "span": 4
      }
    }, [_c('UploadImg', {
      attrs: {
        "image": item.icon_url,
        "url": _vm.url + 'creative/icon'
      },
      on: {
        "update:image": function($event) {
          return _vm.imageUploadSuccess($event, index)
        }
      }
    }), _vm._v(" "), _c('el-input', {
      staticClass: "input",
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "disabled": !item.isAdd,
        "placeholder": "请输入图片名称",
        "clearable": ""
      },
      model: {
        value: (item.icon_name),
        callback: function($$v) {
          _vm.$set(item, "icon_name", $$v)
        },
        expression: "item.icon_name"
      }
    })], 1), _vm._v(" "), _c('el-col', {
      staticStyle: {
        "margin": "0  0 10px 0"
      },
      attrs: {
        "span": 4
      }
    }, [_c('img', {
      staticStyle: {
        "width": "148px"
      },
      attrs: {
        "src": item.icon_url_r
      }
    }), _vm._v(" "), _c('div', [_vm._v("圆角图")])]), _vm._v(" "), _c('el-col', {
      staticStyle: {
        "margin": "0  0 10px 0"
      },
      attrs: {
        "span": 13
      }
    }, [(_vm.creativeIconList.length > 0) ? _c('ul', {
      staticClass: "iconImgList"
    }, [_vm._l((_vm.creativeIconList), function(it, idx) {
      return _c('li', {
        on: {
          "click": function($event) {
            return _vm.copyIconImage(it, index)
          }
        }
      }, [_c('img', {
        attrs: {
          "src": it.url
        }
      })])
    }), _vm._v(" "), _c('li', [_vm._v("推荐Icon")])], 2) : _vm._e()])], 1) : _vm._e()], 1)
  })], 2) : _vm._e(), _vm._v(" "), (_vm.chooseProduct.jump_type == 2) ? _c('div', [_c('el-form-item', {
    attrs: {
      "label": "请选择创意组合",
      "prop": "jump_type"
    }
  }, [_c('el-select', {
    staticClass: "xs24",
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "请选择创意组合名称"
    },
    model: {
      value: (_vm.chooseProduct.creative_bale_id),
      callback: function($$v) {
        _vm.$set(_vm.chooseProduct, "creative_bale_id", $$v)
      },
      expression: "chooseProduct.creative_bale_id"
    }
  }, _vm._l((_vm.creativeGroupList), function(item, i) {
    return _c('el-option', {
      key: item.creativebale_id,
      attrs: {
        "label": item.name,
        "value": item.creativebale_id
      }
    })
  }), 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.editDialog = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "更新日志",
      "visible": _vm.logDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.logDialog = $event
      }
    }
  }, [_c('el-table', {
    attrs: {
      "data": _vm.plog
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "username",
      "label": "操作人员",
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "create_time",
      "label": "更新时间",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "content",
      "label": "备忘"
    }
  })], 1)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('colgroup', [_c('col', {
    attrs: {
      "name": "el-table_2_column_11",
      "width": "5%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "name": "el-table_2_column_13",
      "width": "10%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "name": "el-table_2_column_14",
      "width": "10%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "name": "el-table_2_column_15",
      "width": "10%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "name": "el-table_2_column_88",
      "width": "10%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "name": "el-table_2_column_89",
      "width": "20%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "name": "el-table_2_column_90",
      "width": "10%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "name": "el-table_2_column_91",
      "width": "15%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "name": "el-table_2_column_89",
      "width": "10%"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "has-gutter"
  }, [_c('tr', {}, [_c('th', {
    staticClass: "el-table_2_column_11  is-center   is-leaf",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("ID")])]), _vm._v(" "), _c('th', {
    staticClass: "el-table_2_column_12  is-center  ",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("广告主游戏")])]), _vm._v(" "), _c('th', {
    staticClass: "el-table_2_column_13  is-center   is-leaf",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("产品来源")])]), _vm._v(" "), _c('th', {
    staticClass: "el-table_2_column_14  is-center   is-leaf",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("组合名称")])]), _vm._v(" "), _c('th', {
    staticClass: "el-table_2_column_15  is-center   is-leaf",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("创意个数")])]), _vm._v(" "), _c('th', {
    staticClass: "el-table_2_column_88  is-center   is-leaf",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("产品路径")])]), _vm._v(" "), _c('th', {
    staticClass: "el-table_2_column_89  is-center   is-leaf",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("​产品状态")])]), _vm._v(" "), _c('th', {
    staticClass: "el-table_2_column_90  is-center   is-leaf",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("更新时间")])]), _vm._v(" "), _c('th', {
    staticClass: "el-table_2_column_91  is-center   is-leaf",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("操作")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4f10b71e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/adControl/Creative.vue
// module id = 1103
// module chunks = 2